module.exports = __webpack_public_path__ + "img/admin-2018-postdoc.da68e58a.jpg";